import { Box, styled } from "@mui/material";
import { colors } from "../../../theme/colors";

export const SuperadminLayoutContainer = styled(Box)({
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  backgroundColor: colors.background.default,
});

export const TopBar = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 40px",
  height: "64px",
  backgroundColor: colors.background.secondary,
  borderBottom: `1px solid ${colors.border.light}`,
  position: "sticky",
  top: 0,
  zIndex: 100,
  flexShrink: 0,
});

export const LogoArea = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 10,
  textDecoration: "none",
  cursor: "pointer",
});

export const UserArea = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 24,
});

export const AvatarCircle = styled(Box)({
  width: 36,
  height: 36,
  borderRadius: "50%",
  backgroundColor: colors.primary.main,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: colors.text.white,
  fontWeight: 700,
  fontSize: 14,
  fontFamily: "Nunito",
  flexShrink: 0,
});

export const LogoutButton = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 6,
  cursor: "pointer",
  color: colors.text.secondary,
  fontSize: 14,
  fontFamily: "Nunito",
  transition: "color 0.2s",
  "&:hover": {
    color: colors.text.primary,
  },
});

export const ContentArea = styled(Box)({
  flex: 1,
  padding: "40px",
  width: "100%",
  margin: "0 auto",
  boxSizing: "border-box",
});
